import React, { useEffect, useState, useRef } from "react";
import "../index.css";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { makeStyles } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  Input,
} from "@material-ui/core";
import {
  getDate,
  prospectDetailsPath,
  getSeconds,
  communicatioTimeLinePath,
  investmentDetailsPath,
  prospectPath,
  investorcommunicationTimeLinePath,
  searchFilter,
  handleSort,
  getToday,
  editProspectPath,
  editInvestPath,
} from "../utils/varialbles";
// import TimePicker from 'react-time-picker';
import toast from "react-hot-toast";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import http from "../services/httpService";
import handleValidation from "../utils/handleValidations";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import AudioPlayer from "material-ui-audio-player";
import { Opacity } from "@mui/icons-material";
import { Cancel, CancelOutlined, CancelRounded } from "@material-ui/icons";
//import audioContext from '../utils/audioContext';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F5F7FA",
    padding: "7px",
    width: "100%",
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
    paddingTop: "6px",
  },
  select: {
    height: 36,
    minWidth: 180,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
function AddCommunicatioTimeLine(props) {
  let history = useHistory();
  const [seconds, setSeconds] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const classes = useStyles();
  const location = useLocation();
  const myparam = location.state;
  let form = {
    cust: "",
    communicationmode: "",
    duration: "0",
    time: "00:00",
    date: "",
    comments: "",
    // "commimage" : "",
    // "commaudio" : ""
    proof: [],
    pf_workbook: "",
  };

  // var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  // var dd = String(tomorrow.getDate()).padStart(2, '0');
  // var mm = String(tomorrow.getMonth() + 1).padStart(2, '0');
  // var yyyy = tomorrow.getFullYear();
  // tomorrow = mm + '-' + dd + '-' + yyyy;
  // (tomorrow);

  var today = new Date();
  const toyear = today.getFullYear();
  var tomonth = today.getMonth() + 1;
  tomonth = tomonth.toString();
  if (tomonth.length < 2) {
    tomonth = "0" + tomonth;
  }
  var todate = today.getDate().toString();
  if (todate.length < 2) {
    todate = "0" + todate;
  }
  today = `${toyear}-${tomonth}-${todate}`;

  // var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  // const tooyear = tomorrow.getFullYear();
  // var toomonth = tomorrow.getMonth() + 1;
  // toomonth = toomonth.toString();
  // if (toomonth.length < 2) {
  //     toomonth = "0" + toomonth;
  // }
  // var toodate = tomorrow.getDate().toString();
  // if (toodate.length < 2) {
  //     toodate = "0" + toodate;
  // }
  // tomorrow = `${tooyear}-${toomonth}-${toodate}`;

  const [formObject, setFromObject] = useState(form);
  // (formObject);

  const [showAudio, setshowAudio] = useState(false);
  const [showImage, setshowImage] = useState(false);

  const validations = {
    communicationmode: {
      conditions: {
        required: false,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },

    duration: {
      conditions: {
        required: false,
      },
      message: "Maximum 500 Words Allowed.!",
      valid: true,
      changed: false,
    },
    time: {
      conditions: {
        required: false,
      },
      message: "Maximum 500 Words Allowed.!",
      valid: true,
      changed: false,
    },
    date: {
      // conditions: {
      //     "required": true,"pattren":/^\d{2}-\d{2}-\d{4}$/,"maxDate":getToday()
      // }, "message": "Maximum 500 Words Allowed.!", "valid": true, "changed": false
      conditions: { required: false },
      message: "Maximum 500 Words Allowed.!",
      valid: true,
      changed: false,
    },
    comments: {
      conditions: {
        required: false,
        maxLength: 1000,
      },
      message: "Maximum 100 Words Allowed.!",
      valid: true,
      changed: false,
    },
  };
  const [validationState, setValidationState] = useState(validations);
  useEffect(() => {
    if (myparam && (myparam.cust__id || myparam.customer_id)) {
      let cust_id = myparam.cust__id || myparam.customer_id;
      setFromObject(form);
      setFromObject({
        ...formObject,
        cust: cust_id,
      });
    } else {
      history.goBack();
    }
  }, []);
  const gotoProspectDetails = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    } else {
      history.push(prospectPath);
    }
  };
  const gotoCommunicationTimeLine = (e) => {
    e.preventDefault();
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: editProspectPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: editInvestPath,
        state: myparam,
      });
    }
  };
  const handleChange = (event) => {
    // (event.target.name);
    // (event.target.value);
    let name = event.target.name;
    let value = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    if (name && validStateTemp.hasOwnProperty(name)) {
      let validation = handleValidation(name, value, validStateTemp);

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value === 0) {
      setFromObject({
        ...formObject,
        [event.target.name]: event.target.value,
      });
    }
    if (
      event.target.name === "communicationmode" &&
      event.target.value === ""
    ) {
      setshowImage(false);
      setshowAudio(false);
    }
    if (
      event.target.name === "communicationmode" &&
      event.target.value === "call"
    ) {
      setshowAudio(true);
      setshowImage(false);
    }
    if (
      event.target.name === "communicationmode" &&
      event.target.value === "whatsapp"
    ) {
      setshowImage(true);
      setshowAudio(false);
    }
    if (
      event.target.name === "communicationmode" &&
      event.target.value !== "whatsapp" &&
      event.target.value !== "call"
    ) {
      setshowImage(false);
      setshowAudio(false);
    }
  };

  // const [baseImage, setBaseImage] = useState("");

  // const [getMultipleFiles, setMultipleFiles] = useState([]);
  // const [getMultipleFilesName, setMultipleFilesName] = useState([]);

  const handleImageChange = async (event) => {    
    const fileType = event.target.files[0].type;
    // console.log(fileType, "fileType");
    if (
      fileType === "video/mp4" ||
      fileType === "video/webm" ||
      fileType === "video/x-m4v"
    ) {
      toast.error("Do not upload video files");
    } else {
      const file = event.target.files[0];

      const base64 = await convertBase64(file);

      setFromObject({ ...formObject, proof: base64 });
    }

    //   setMultipleFiles((preval) => {
    //     const updatedFiles = [...preval, base64];
    //     setFromObject({ ...formObject, proof: updatedFiles });
    //     return updatedFiles;
    // });
    // setMultipleFilesName((prename) => [...prename, event.target.files[0].name]);
  };

  const handlePfFile = async (event) => {    
    const fileType = event.target.files[0].type;
    console.log(fileType, "fileType");
    if (
      fileType !== "application/vnd.ms-excel" &&
      fileType !== "application/excel" &&
      fileType !== "application/x-excel" &&
      fileType !== "application/x-msexcel" &&
      fileType !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      fileType !== "text/csv" && 
      fileType !== "application/pdf"
    ) {
      toast.error("Please select a valid Excel or CSV or PDF file.");
    } else {
      const file = event.target.files[0];

      const base64 = await convertBase64(file);

      setFromObject({ ...formObject, pf_workbook: base64 });
    }
  };
  console.log(formObject, "formobject");
  //   const handleAudioChange = async (event) => {
  //     //alert("file received");
  //     const file = event.target.files[0];
  //     // (file);
  //     // (file.name);
  //     const base64 = await convertBase64(file);
  //     //setBaseImage(base64);
  //     setFromObject({ ...formObject, proof: base64 });
  //     // (formObject.commaudio);
  //   };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let totalSeconds = getSeconds(
      seconds.hours,
      seconds.minutes,
      seconds.seconds
    );
    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObject = { ...formObject };
    let validData = handleSubmitValidation(finalObject, validStateTemp);
    validCount = validData.validCount;
    // (finalObject)
    if (validCount === 0) {
      finalObject["duration"] = totalSeconds;
      if (formObject.cust) {
        http
          .post("/addcommunicationlog", finalObject)
          .then((res) => {
            if (res.data.Data && res.data.Data !== "Exception") {
              toast.success(res.data.Data);
              if (myparam && myparam.cust__id) {
                history.push({
                  pathname: editProspectPath,
                  state: myparam,
                });
              }
              if (myparam && myparam.customer_id) {
                history.push({
                  pathname: editInvestPath,
                  state: myparam,
                });
              }
            } else {
              toast.error("Communication time line Adding failed!");
            }
          })
          .catch((error) => {
            toast.error("Communication time line Adding failed!");
          });
      }
    } else {
      // (validData.validStateTemp)
      setValidationState(validData.validStateTemp);
      toast.error("Please check Errors in Field level!");
    }
  };
  const handleDateChange = (e) => {
    //     let name = "time";
    //     let value = e;
    //     let valid = true;
    //     // (e)
    //     let validStateTemp = { ...validationState }
    //     if (name && validStateTemp.hasOwnProperty(name)) {
    //         let validation = handleValidation(name, value, validStateTemp);

    //         setValidationState(validation.validStateTemp)
    //         valid = true
    //     }
    //     if (valid || value === "" || value === 0) {
    //     setFromObject({
    //         ...formObject,
    //         time: e
    //     });
    // }

    setFromObject({ ...formObject, time: e.target.value });
  };
  const handleTimeChange = (e) => {
    setSeconds({
      ...seconds,
      [e.target.name]: e.target.value,
    });
  };
  const checkValue = (e) => {};
  const columns = [
    {
      value: "communicationmode",
      imp: false,
      label: "Mode of Communication",
      minWidth: 150,
      filedType: "dropdown",
      options: [
        { label: "Phone Call", value: "call" },
        { label: "WhatsApp", value: "whatsapp" },
        { label: "Walk-In", value: "walkin" },
      ],
    },
    { value: "proof", imp: false, label: "", minWidth: 150, filedType: "file" },
    // {
    //   value: "proof",
    //   imp: false,
    //   label: "",
    //   minWidth: 150,
    //   filedType: "audio",
    // },
    {
      value: "pf_workbook",
      imp: false,
      label: (showAudio || showImage) && "Upload PF file",
      minWidth: 150,
      filedType: "pffile",
    },
    {
      value: "duration",
      imp: false,
      label: showAudio && "Call Duration",
      minWidth: 150,
      filedType: "seconds",
    },
    {
      value: "time",
      imp: false,
      label: "Time",
      minWidth: 150,
      filedType: "time",
    },
    {
      value: "date",
      imp: false,
      label: "Date",
      minWidth: 150,
      filedType: "date",
    },
    {
      value: "comments",
      imp: false,
      label: "Comments",
      minWidth: 150,
      filedType: "textarea",
      multiline: true,
      rows: 3,
    },
  ];

  // const deleteUploadFile = (arrayIndex) => {
  //   const result = [...getMultipleFilesName]; // Create a copy of the array
  //   result.splice(arrayIndex, 1); // Remove the item at the specified index
  //   setMultipleFilesName(result); // Update the state with the modified array

  //   const uploadedFiles = [...getMultipleFiles]; // Create a copy of the array
  //   uploadedFiles.splice(arrayIndex, 1); // Remove the item at the specified index
  //   setMultipleFiles(uploadedFiles); // Update the state with the modified array

  //     setFromObject({ ...formObject, proof: uploadedFiles });

  // };

  return (
    <Grid container component="main">
      <Paper className={classes.root}>
        <Grid container>
          <Grid item xs={12} sm={6} md={1}>
            <Button
              name="Overview"
              variant="contained"
              color="primary"
              onClick={gotoProspectDetails}
            >
              Overview
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Grid item xs={false} sm={6} md={4} style={{ marginTop: 30 }}>
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={gotoCommunicationTimeLine}
        >
          Back
        </Button>
      </Grid>
      <Grid item xs={false} sm={6} md={6} style={{ marginTop: 30 }}>
        <Typography color="textPrimary" variant="h5">
          Add Communication Log
        </Typography>
      </Grid>
      <Grid container style={{ marginTop: 50 }}>
        {columns.map((question) => {
          return (
            <Grid container className={classes.paper}>
              <Grid item sm={2} md={2}>
                <InputLabel className={classes.lableColor} id={question.lable}>
                  {question.label}
                  {question.imp && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "1.2rem",
                        marginLeft: "0.2rem",
                      }}
                    >
                      *
                    </span>
                  )}
                </InputLabel>
                {question.filedType === "file" && (showAudio || showImage) ? (
                  <>
                    <InputLabel className={classes.lableColor}>
                      Upload File
                    </InputLabel>
                  </>
                ) : null}
              </Grid>
              <Grid item md={6} sm={6}>
                {question.filedType === "text" ? (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value]}
                    name={question.value}
                    className={classes.select}
                    onChange={handleChange}
                    style={{ width: 250, borderBottom: "2px solid gray" }}
                  />
                ) : question.filedType === "textarea" ? (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value]}
                    name={question.value}
                    className={classes.select}
                    onChange={handleChange}
                    multiline
                    rows={question.rows}
                    style={{ width: 250, marginBottom: 80 }}
                    error={
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : `${formObject[question.value].length}/${
                            validationState[question.value]["conditions"][
                              "maxLength"
                            ]
                          }`
                    }
                  />
                ) : question.filedType === "dropdown" ? (
                  <>
                    <Select
                      displayEmpty
                      labelId="statusLable"
                      id="statusSelect"
                      variant="outlined"
                      className={classes.select}
                      onChange={handleChange}
                      value={
                        formObject[question.value]
                          ? formObject[question.value]
                          : ""
                      }
                      name={question.value}
                      style={{ width: 250, height: 40, border: "transparent" }}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {question.options.map((option) => {
                        return (
                          <MenuItem value={option.value}>
                            {option.label}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"] ? (
                      <div
                        style={{
                          color: "#f44336",
                          fontSize: "0.75rem",
                          margin: "3px 14px",
                          width: 250,
                        }}
                      >
                        {validationState[question.value]["message"]}
                      </div>
                    ) : null}
                  </>
                ) : question.filedType === "time" ? (
                  <>
                    {/* <TimePicker format="HH:mm" name={question.value}
                                                style={{border:'transparent'}}
                                                onChange={(value) => handleDateChange(value)}
                                                onBlur={checkValue} required
                                                value={formObject[question.value]} openClockOnFocus={false} showLeadingZeros={false}
                                            /> */}
                    <TextField
                      id="time"
                      // label="Alarm clock"
                      type="time"
                      name={question.value}
                      onChange={(value) => handleDateChange(value)}
                      onBlur={checkValue}
                      required
                      value={formObject[question.value]}
                      style={{
                        width: 250,
                        height: 40,
                        margin: "10px 0px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        paddingLeft: 5,
                      }}
                    />
                    {validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"] ? (
                      <div
                        style={{
                          color: "#f44336",
                          fontSize: "0.75rem",
                          margin: "3px 14px",
                          width: 250,
                        }}
                      >
                        {validationState[question.value]["message"]}
                      </div>
                    ) : null}
                  </>
                ) : question.filedType === "date" ? (
                  <TextField
                    id="datePickerId"
                    label="Select Date"
                    type="date"
                    // defaultValue="07:30"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    format="YYYY-MM-DD"
                    value={
                      formObject[question.value]
                        ? formObject[question.value]
                        : ""
                    }
                    onChange={handleChange}
                    name={question.value}
                    style={{ width: 250 }}
                    InputProps={{ inputProps: { max: today } }}
                    style={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? { paddingBottom: 20, width: 250 }
                        : { width: 250 }
                    }
                    error={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : ""
                    }
                  />
                ) : showAudio && question.filedType === "seconds" ? (
                  <Grid container style={{ alignItems: "center" }}>
                    <Grid className="subgrid">
                      <Select
                        displayEmpty
                        value={seconds.hours}
                        variant="outlined"
                        name="hours"
                        onChange={handleTimeChange}
                      >
                        {Array.from(Array(24).keys()).map((value) => {
                          return (
                            <MenuItem key={"h" + value} value={value}>
                              {value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {/* <span>:</span> */}
                    </Grid>
                    <span className="subgridspan">:</span>
                    <Grid className="subgrid">
                      <Select
                        displayEmpty
                        value={seconds.minutes}
                        variant="outlined"
                        name="minutes"
                        onChange={handleTimeChange}
                      >
                        {Array.from(Array(60).keys()).map((value) => {
                          return (
                            <MenuItem key={"m" + value} value={value}>
                              {value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {/* <span>:</span> */}
                    </Grid>
                    <span className="subgridspan">:</span>
                    <Grid className="subgrid">
                      <Select
                        displayEmpty
                        value={seconds.seconds}
                        variant="outlined"
                        name="seconds"
                        onChange={handleTimeChange}
                      >
                        {Array.from(Array(60).keys()).map((value) => {
                          return (
                            <MenuItem key={"s" + value} value={value}>
                              {value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Grid>
                  </Grid>
                ) : question.filedType === "file" &&
                  (showAudio || showImage) ? (
                  <Grid container>
                    <Grid item>
                      <input
                        type="file"
                        onChange={(e) => {
                          handleImageChange(e);
                        }}
                        name="proof"
                        multiple={false}
                        accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                      />

                      <div
                        style={{
                          display: "flex",
                          columnGap: 10,
                          marginTop: 10,
                        }}
                      >
                        {/* {getMultipleFilesName.map((item, index) => {
                          return (
                            <div
                              style={{
                                fontWeight: "normal",
                                border: "1px solid",
                                fontSize: 15,
                                padding: "5px 5px",
                                borderRadius: 5,
                              }}
                            >
                              {item}{" "}
                              <CancelOutlined
                                style={{
                                  verticalAlign: "middle",
                                  fontSize: 18,
                                  marginLeft: 5,
                                  cursor: "pointer",
                                }}
                                onClick={() => deleteUploadFile(index)}
                              />
                            </div>
                          );
                        })} */}
                      </div>
                      {/* <InputLabel>Upload WhatsApp Screenshot Image</InputLabel> */}
                    </Grid>
                  </Grid>
                ) : question.filedType === "pffile" &&
                  (showAudio || showImage) ? (
                  <Grid container>
                    <Grid item>
                      <input
                        type="file"
                        onChange={(e) => {
                          handlePfFile(e);
                        }}
                        name="pf_workbook"
                        multiple={false}
                        // accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                        // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv"
                      />
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>

      <Grid container className={classes.submitButton}>
        <Grid item xs={false} sm={3} md={3}></Grid>

        <Grid item xs={3} sm={6} md={6}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Add
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AddCommunicatioTimeLine;
